import config from '@/services/config'
import Icons from '@/icons'
import { checkAccess, getDataForCardBack } from '@/services/storiesonboardrepository';


class CardBackModule implements ICardBackSectionProvider {

    public async getCardBackSection(t: ITrelloClient, opts: any): Promise<any> {
      var cfg = await config(t).get();
      if (cfg.isShowStoryAttachemtns) {
        const hasAccess = await checkAccess(t);
        if(hasAccess){
            const cardId = t.getContext().card;
            const cardBackData = await getDataForCardBack(t, cardId);
            if(cardBackData != null && cardBackData.Attachments.length > 0) {
              return {
                title: 'Story attachments',
                icon: Icons.AppIcon, // Must be a gray icon, colored icons not allowed.
                content: {
                  type: 'iframe',
                  url: t.signUrl('./views/cardback.html',{}),
                  height: 50 // Max height is 500,
                }
              }
            }
        }
      }
      
      return null; 
    }
}

export var cardBackModule = new CardBackModule();
export default cardBackModule;
